export const APPLY_CHANNELS_FILTERS = 'APPLY_CHANNELS_FILTERS';
export const CHANNELS_PACKAGE_ID = 'CHANNEL_PACKAGE_ID';
export const CLEAR_CHANNELS_PACKAGE_ID = 'CLEAR_CHANNELS_PACKAGE_ID';
export const CLEAR_SEARCH_CHANNELS_FILTER = 'CLEAR_SEARCH_CHANNELS_FILTER';
export const CLEAR_TARIFF_CHANNEL = 'CLEAR_TARIFF_CHANNEL';
export const CLEAR_THEME_CHANNELS_FILTER = 'CLEAR_THEME_CHANNELS_FILTER';
export const GET_ALL_CHANNELS = 'GET_ALL_CHANNELS';
export const GET_BUNDLES_BANNER = 'GET_BUNDLES_BANNER';
export const GET_BUNDLES_TARIFFS = 'GET_BUNDLES_TARIFFS';
export const GET_BUNDLES_TARIFFS_SELF_ORDER = 'GET_BUNDLES_TARIFFS_SELF_ORDER';
export const GET_CHANNELS_BY_BIDS = 'GET_CHANNELS_BY_BIDS';
export const GET_CHANNEL_THEMES = 'GET_CHANNEL_THEMES';
export const SET_FILTERED_TARIFFS_ID = 'SET_FILTERED_TARIFFS_ID';
export const SET_FILTER_FOR_CHANNELS = 'SET_FILTER_FOR_CHANNELS';
export const SET_SEARCH_CHANNELS_FILTER = 'SET_SEARCH_CHANNELS_FILTER';
export const SET_SELECTED_TARIFF_ID = 'SET_SELECTED_TARIFF_ID';
export const SET_TARIFF_CHANNELS = 'SET_TARIFF_CHANNELS';
export const SET_THEME_CHANNELS_FILTER = 'SET_THEME_CHANNELS_FILTER';
